import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';

export default function ProjectCard({ project, index = 0 }) {
  return (
    <motion.article
      className="project-card"
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ delay: index * 0.06, duration: 0.45 }}
      whileHover={{ y: -7 }}
    >
      <div className="project-top">
        <div className="project-icon">
          <SafeIcon icon={FiIcons[project.icon]} />
        </div>
        <span>{project.industry}</span>
      </div>
      <h3>{project.name}</h3>
      <p>{project.solution}</p>
      <div className="project-result">
        <strong>{project.results}</strong>
        <small>Impact delivered</small>
      </div>
      <div className="tech-line">{project.technologies}</div>
    </motion.article>
  );
}